import Currency from "../components/Currency";

/**
 * Convert cents or pence to bucks, loonies, or quid
 */
export const centsToCurrencyString = (cents: number): string => {
  return Currency({ value: cents / 100 });
};
